import { defaultConsents, getUserConsent } from "@fruugo/utilities";
var enabledCountries = ["SE"];
var userId = "unknown";
var currentCountry = window.currentCountry;
export function shouldEnableRTBHouse() {
    var consents = getUserConsent() || defaultConsents;
    return consents.advertising && enabledCountries.includes(currentCountry);
}
export function initRTBHouseTracking() {
    if (!shouldEnableRTBHouse())
        return;
    (function (w, d, dn, t) {
        // @ts-ignore
        w[dn] = w[dn] || [];
        // @ts-ignore
        w[dn].push({ eventType: "init", value: t, dc: "" });
        var f = d.getElementsByTagName("script")[0], c = d.createElement("script");
        c.async = true;
        c.src = "https://tags.creativecdn.com/lS4uLZeAFEWiNnbn9H7W.js";
        // @ts-ignore
        f.parentNode.insertBefore(c, f);
    })(window, document, "rtbhEvents", "lS4uLZeAFEWiNnbn9H7W");
}
export function sendRTBHomePageViewEvent() {
    if (!shouldEnableRTBHouse())
        return;
    // @ts-ignore
    (rtbhEvents = window.rtbhEvents || []).push({
        eventType: "home",
    }, {
        eventType: "uid",
        id: userId,
    });
}
export function sendRTBProductPageViewEvent(productId) {
    if (!shouldEnableRTBHouse())
        return;
    if (!productId)
        return;
    // @ts-ignore
    (rtbhEvents = window.rtbhEvents || []).push({
        eventType: "offer",
        offerId: productId,
    }, {
        eventType: "uid",
        id: userId,
    });
}
export function sendRTBAddToCartEvent(productId) {
    if (!shouldEnableRTBHouse())
        return;
    if (!productId)
        return;
    // @ts-ignore
    (rtbhEvents = window.rtbhEvents || []).push({
        eventType: "basketadd",
        offerId: productId,
    }, {
        eventType: "uid",
        id: userId,
    });
}
